import React, { useEffect, useState } from 'react';
import { Box, Text, Center, Spinner, useTheme } from 'native-base';
import { Platform, Dimensions } from 'react-native';
import GoBackButton from '../common/GoBackButton';
import { useAuthState } from '../../../context/auth/index';
import { useTopicsDispatch, useTopicsState, topicsAPI } from '../../../context/topics';
import { useCategoriesState } from '../../../context/categories';
import { useModeratorState } from '../../../context/moderator';
import { useEnvState } from '../../../context/env';
import { flattenProductCategories } from '../../utils/helpers';
import Topic from './Topic';
const SingleTopicScreen = ({
  navigation,
  route
}) => {
  var _route$params, _route$params2, _route$params3, _route$params4, _route$params5, _route$params6, _route$params7, _route$params8, _route$params9, _allProductCategories;
  const theme = useTheme(),
    {
      breakpoints,
      colors
    } = theme;
  const envState = useEnvState();
  const authState = useAuthState();
  const topicsDispatch = useTopicsDispatch();
  const topicsState = useTopicsState();
  const {
    refresh_replies_topic_id,
    refresh_replies_topic_timestamp,
    flagged_post_id
  } = topicsState;
  const moderatorState = useModeratorState();
  const [topic, setTopic] = useState({});
  const [firstPost, setFirstPost] = useState({
    id: ''
  });
  // TODO: use rendered_post_count from Topic component instead of working independently
  const [renderedLikeCount, setRenderedLikeCount] = useState(0);
  const [displayedReplies, setDisplayedReplies] = useState([]);
  const [allReplies, setAllReplies] = useState([]);
  const [repliesStream, setRepliesStream] = useState([]);
  const [page, setPage] = useState(1);
  const [loadMoreRepliesSpinner, setLoadMoreRepliesSpinner] = useState(false);
  const [forceReloadToggle, setForceReloadToggle] = useState(false);
  const topicId = route === null || route === void 0 || (_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.topicId;
  const normalizeUrl = route === null || route === void 0 || (_route$params2 = route.params) === null || _route$params2 === void 0 ? void 0 : _route$params2.normalizeUrl;
  const likedReplyIDs = route === null || route === void 0 || (_route$params3 = route.params) === null || _route$params3 === void 0 ? void 0 : _route$params3.likedReplyIDs;
  const addLikedReplyID = route === null || route === void 0 || (_route$params4 = route.params) === null || _route$params4 === void 0 ? void 0 : _route$params4.addLikedReplyID;
  const removeLikedReplyID = route === null || route === void 0 || (_route$params5 = route.params) === null || _route$params5 === void 0 ? void 0 : _route$params5.removeLikedReplyID;
  const loadContents = route === null || route === void 0 || (_route$params6 = route.params) === null || _route$params6 === void 0 ? void 0 : _route$params6.loadContents;
  const showUserProfile = route === null || route === void 0 || (_route$params7 = route.params) === null || _route$params7 === void 0 ? void 0 : _route$params7.showUserProfile;
  const trackForum = route === null || route === void 0 || (_route$params8 = route.params) === null || _route$params8 === void 0 ? void 0 : _route$params8.trackForum;
  const forumKey = route === null || route === void 0 || (_route$params9 = route.params) === null || _route$params9 === void 0 ? void 0 : _route$params9.forumKey;
  const categoriesState = useCategoriesState();
  const {
    rootProductCategory
  } = categoriesState;
  let allProductCategories = flattenProductCategories(rootProductCategory);
  const categoryName = allProductCategories === null || allProductCategories === void 0 || (_allProductCategories = allProductCategories.filter(category => (category === null || category === void 0 ? void 0 : category.id) === (topic === null || topic === void 0 ? void 0 : topic.category_id))[0]) === null || _allProductCategories === void 0 ? void 0 : _allProductCategories.name;
  useEffect(() => {
    loadSingleTopicContents();
  }, [topicId, refresh_replies_topic_id, refresh_replies_topic_timestamp, moderatorState.topic_id_with_new_category, moderatorState.pinned_topic_id, moderatorState.unpinned_topic_id, flagged_post_id, topic === null || topic === void 0 ? void 0 : topic.notification_level, topic === null || topic === void 0 ? void 0 : topic.title]);
  const updateTopicPost = id => {
    updateTopicReplies(id);
  };
  const loadSingleTopicContents = async () => {
    try {
      const lastPage = true;
      const response = await topicsAPI.getSingleTopic(envState.base_url, authState.api_key, topicId, lastPage);
      if (response && response.post_stream) {
        const {
          posts,
          stream
        } = response.post_stream;
        if (posts && stream) {
          var _response$details;
          response.first_post && setFirstPost(response.first_post);
          if (firstPost && firstPost.actions_summary) {
            let likeObj = firstPost.actions_summary.filter(a => a.id === 2)[0];
            if (likeObj) setRenderedLikeCount(likeObj.count ? likeObj.count : 0);
          }

          // add first post to posts if it isn't already present there
          response.first_post && !posts.map(p => p.id).includes(response.first_post.id) && posts.push(response.first_post);
          const sortedReplies = posts.sort((a, b) => a.post_number - b.post_number);
          setAllReplies(sortedReplies);
          let replies = sortedReplies.slice(1);
          setDisplayedReplies(replies);
          setRepliesStream(stream);
          /* let's add properties to this object before setTopic
           * that the Topic component expects from the digest
           */
          response.first = {
            post: sortedReplies[0]
          };
          response.recent = replies.map(r => {
            return {
              post: r
            };
          });
          response.forceReloadToggle = forceReloadToggle;
          response.original_poster = (_response$details = response.details) === null || _response$details === void 0 ? void 0 : _response$details.original_poster;
          setTopic(response);
          return response;
        }
      }
      throw new Error('Failed to get single topic.');
    } catch (err) {
      console.log('Error while loading the topic');
      navigation.navigate('Topics');
    }
  };
  const updateTopicReplies = async updatedTopicId => {
    setForceReloadToggle(!forceReloadToggle);
    topicsDispatch({
      type: 'SET_REFRESH_REPLIES_TOPIC_ID',
      payload: updatedTopicId
    });
    topicsDispatch({
      type: 'SET_REFRESH_REPLIES_TOPIC_TIMESTAMP',
      payload: Date()
    });
  };
  const updateForceReloadTopics = async () => {
    topicsDispatch({
      type: 'SET_FORCE_RELOAD_TOPICS',
      payload: true
    });
  };

  /* Final value for mobile (Dimensions.get('window').height - 160}px) has 160 subtracted
   * to account for top and bottom bars */

  return /*#__PURE__*/React.createElement(Box, {
    h: Platform.OS === 'web' ? window.innerWidth > breakpoints.lg ? '85vh' : '80vh' : `${Dimensions.get('window').height - 160}px`,
    bg: colors.topic.box.bg,
    p: 3
  }, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: navigation,
    normalizeUrl: normalizeUrl
  }), topic && topic.id ? /*#__PURE__*/React.createElement(Topic, {
    updateTopicPost: updateTopicPost,
    updateTopicReplies: updateTopicReplies,
    topic: topic,
    forumKey: forumKey,
    navigation: navigation,
    loadContents: loadContents,
    updateForceReloadTopics: updateForceReloadTopics,
    showUserProfile: showUserProfile,
    forSingleTopicScreen: true,
    repliesStream: repliesStream,
    forceReloadToggle: forceReloadToggle,
    trackForum: trackForum
  }) : /*#__PURE__*/React.createElement(Center, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Spinner, {
    mb: 3
  }), /*#__PURE__*/React.createElement(Text, null, "Loading Topic...")));
};
export default SingleTopicScreen;
//# sourceMappingURL=SingleTopicScreen.js.map